import { observable, action, computed } from 'mobx'
import Constants from '../common/Constants';
import BetslipAction from '../components/BetslipComponent/BetslipAction';
import { DEFAULT_ATTENTION } from '../common/Foundation';

const initAsiaParlayData = {
  stake: '',
  selectedRoundRobins: []
}

const initAsiaTeaserData = {
  stake: '',
  teaserAcceptBetterOdds: false
}

const initAsiaSingleData = {
  outRightAcceptBetterOdds: false,
  normalAcceptBetterOdds: false,
  stakePerBet: '',
  pendingBets: []
}



export default class NewBetslipStore {
  @observable winRiskOption = Constants.WIN_RISK_OPTION.BASE; // default is BASE

  @observable oddsSelections = []; 

  @observable oddsReuseSelections = []; //reuse Selection

  @observable teaserBetPayload = {}; // use to save payload for teaser bets when perform place bet.

  @observable teaserBetItems = {}; // use to render teaser betslip ui

  @observable normalBetsResponse = [];
  @observable winRiskInfoData = {};

  @observable teaserBetsResponse = [];

  @observable initStakeReuse = 0;

  @observable currentTab = '';

  @observable isTriggerRedirect = false;

  @observable processingQueue = [];

  @observable showPendingToast = false;

  @observable enableMaxbet = false;

  @observable initStake = ''

  @observable isDisableInputStake = false;
  //Reuse Selection
  @observable isReuseSelection = false;
  @observable isFirstTimeBet = false;
  @observable isChangeWinRiskByReuse = false;
  @observable asiaTeaserReuseSelections = [];
  @observable asiaTeaserReuseStake = 0;
  @observable ticketId = '';

  @observable asiaSingleSelection = []
  @observable asiaNormalBetItem = []
  @observable reuseAsiaSingleInputs = {}
  @observable reuseAsiaNormalBetItem = [] // use for reuse normal selection on toast component
  @observable reuseAsiaParlayBetItem = {} // use for reuse parlay selection on toast component
  @observable reuseAsiaParlayData = {} // use for reuse parlay selection on toast component
  @observable isExpandBetSlip = false
  @observable potentialWinnings = 0
  @observable isLoading = false
  @observable betslipDisp = false
  @observable validateWarning = ''
  @observable displayMaxBetWarning = ''

  @observable asiaSingleInputs = {}
  @observable newAsiaSingleData = initAsiaSingleData
  @observable parlayBetSuccessRes = {}
  @observable teaserBetSuccessRes = {}
  @observable asiaTeaserSelections = []
  @observable asiaActiveBetslip = ''
  @observable asiaOutrightBetItem = ''
  @observable asiaTeaserBetItem = {}
  @observable asiaParlayData = initAsiaParlayData
  @observable asiaParlayTicket = {}
  @observable asiaTeaserTicket = {}
  @observable asiaPitchers = []
  @observable asiaTeaserData = initAsiaTeaserData
  @observable sportTeaserHasEvent = []

  @observable startCountdown = false
  @observable resetCountdown = false

  // Use to prevent clear reuse selection when status is pending and user close the betslip
  @observable isSupportedPendingAcceptance = false

  @observable attention = {
    single: DEFAULT_ATTENTION,
    parlay: DEFAULT_ATTENTION
  };
  @observable showAttention = false

  @observable maxParlayOdds = 0

  @observable isParlayMaxOddsError = false

  // Ex: [
  //  {eventId: eventId1, maxBet: maxBet1, totalStake: totalStake1, childIds: []}, 
  //  {eventId: eventId2, maxBet: maxBet2, totalStake: totalStake2, childIds: []}
  // ]
  @observable singleEventIdsHasCorrelated = [] 

  /************************************************************
   *    GET AND SET
   ************************************************************/  

  @action setSupportedPendingAcceptance(isSupportedPendingAcceptance) {
    this.isSupportedPendingAcceptance = isSupportedPendingAcceptance
  }

  @action updateInitStake(stake) {
    this.initStake = stake
  }

  @action updateResetCountdown(payload) {
    this.resetCountdown = payload;
  }

  @action updateStartCountdown(payload) {
    this.startCountdown = payload;
  }

  @action changeWinRiskOption(value) {
    this.winRiskOption = value;
  }

  @action updateTeaserBetPayload(payload) {
    this.teaserBetPayload = payload;
  }

  @action updateInitStakeReuse(stake) {
    this.initStakeReuse = stake;
  }

  @action updateOddsSelections(oddsSelections) {
    this.oddsSelections = oddsSelections;
    this.cacheOddsSelections(this.oddsSelections)
  }

  @action addOddsSelections(selection) {
    const tmp = this.oddsSelections.filter(item => {
      return item.oddsId === selection.oddsId;
    })
    if (tmp.length < 1) {
      this.oddsSelections.push(selection);
      this.cacheOddsSelections(this.oddsSelections);
    }
  }

  @action cacheOddsSelections() {
    localStorage.removeItem('oddsSelections')
    localStorage.setItem('oddsSelections', JSON.stringify(this.oddsSelections));
  }

  @action resetAsiaParlayData() {
    this.asiaParlayData = initAsiaParlayData;
  }

  @action resetAsiaTeaserData() {
    this.asiaTeaserData = initAsiaTeaserData;
  }

  @action updateSportTeaserHasEvent(data) {
    this.sportTeaserHasEvent = data
  }
  
  @action updateShowAttention(data) {
    this.showAttention = data
  }
  @action updateAttention(data) {
    this.attention = {...this.attention , [this.asiaActiveBetslip]: data}
  }
  
  @action resetAttentionData() {
    this.attention[this.asiaActiveBetslip] = DEFAULT_ATTENTION;
    this.showAttention = false;
  }

  @computed get isStartCountdown() {
    return this.startCountdown;
  }


  @computed get getAsiaTeaserSelections() {
    return this.asiaTeaserSelections;
  }

  @computed get getWinRiskOption() {
    return this.winRiskOption;
  }

  @computed get getSingleSelections() {
      return this.asiaSingleSelection
  }

  @computed get getParlaySelections() {
    return this.asiaSingleSelection.filter(sel => sel.oddsSelectionsType !== Constants.WAGER_TYPE.OUTRIGHT)
}

  @computed get submitBtnDisabled() {
    if(this.isLoading) return true
    switch (this.asiaActiveBetslip) {
      case Constants.ASIA_BETSLIP_TYPES.SINGLE:
        return (
          !BetslipAction.getValidBetForSubmit(this.asiaNormalBetItem, this.asiaSingleInputs).length
          || BetslipAction.getValidBetForSubmit(this.asiaNormalBetItem, this.asiaSingleInputs).length < Object.keys(this.asiaSingleInputs).length 
          || this.getSelectionsCorrelatedInfo.some(item => item.totalStake > item.maxBet)
        );
      case Constants.ASIA_BETSLIP_TYPES.PARLAY:
        return this.asiaSingleSelection.length < 2
          || !BetslipAction.convertStakeToNumber(this.asiaParlayData.stake)
          || !this.asiaParlayTicket.legs
          || this.isParlaySubmited
          || BetslipAction.isDisablePlaceBetBtn(this.asiaParlayTicket.legs)
          || this.isParlayMaxOddsError
      case Constants.ASIA_BETSLIP_TYPES.TEASER:
        return this.asiaTeaserSelections.length < 2
          || !BetslipAction.convertStakeToNumber(this.asiaTeaserData.stake)
          || !this.asiaTeaserTicket.legs
          || this.isTeaserSubmited
      default:
        return true
    }
  }

  @computed get hasSingleData() {
    return !!this.asiaNormalBetItem.length
  }

  @computed get hasParlayData() {
    return !!this.asiaSingleSelection.length || this.isParlaySubmited
  }

  @computed get hasTeaserData() {
    return !!this.asiaTeaserSelections.length || this.isTeaserSubmited
  }

  @computed get isSingleTab() {
    return this.asiaActiveBetslip === Constants.ASIA_BETSLIP_TYPES.SINGLE
  }

  @computed get isParlayTab() {
    return this.asiaActiveBetslip === Constants.ASIA_BETSLIP_TYPES.PARLAY
  }

  @computed get isTeaserTab() {
    return this.asiaActiveBetslip === Constants.ASIA_BETSLIP_TYPES.TEASER
  }

  @computed get isParlaySubmited() {
    return !!this.parlayBetSuccessRes.legs
  }

  @computed get isTeaserSubmited() {
    return !!this.teaserBetSuccessRes.legs
  }

  @computed get getOddItemsLength() {
    switch (this.asiaActiveBetslip) {
      case Constants.ASIA_BETSLIP_TYPES.SINGLE:
        return (this.asiaNormalBetItem || this.asiaSingleSelection).length
      case Constants.ASIA_BETSLIP_TYPES.PARLAY:
        return (this.parlayBetSuccessRes.legs || this.asiaParlayTicket.legs || this.asiaSingleSelection).length
      case Constants.ASIA_BETSLIP_TYPES.TEASER:
        return (this.asiaTeaserTicket.legs || this.asiaSingleSelection).length
      default:
        return 0
    }
  }

  @computed get getSelectionsCorrelatedInfo() {
    if (!this.singleEventIdsHasCorrelated.length) return [];
    return this.singleEventIdsHasCorrelated.map((item) => {
      let totalStake = 0;
      for (const key in this.asiaSingleInputs) {
        if (key.includes(item.eventId) || item.childIds.some(childId => key.includes(childId))) {
          const { stake, odds } = this.asiaSingleInputs[key];
          const stakeToNum = BetslipAction.convertStakeToNumber(this.asiaSingleInputs[key].stake);
          const stakeToRisk = BetslipAction.calculateToRisk(stakeToNum, odds, item.oddsFormat, this.winRiskOption)
          totalStake += isNaN(stakeToNum) ? 0 : stakeToRisk;
        }
      }
      return {
        ...item,
        totalStake,
      };
    });
  }

  /************************************************************
   *  LOGIC FOR UPDATING DATA
   ************************************************************/

  @action clearOddsSelections() {
    this.oddsSelections = [];
    // clear cache
    localStorage.removeItem('oddsSelections')
  }

  @action setAsiaSingleSelection(selection) {
    this.asiaSingleSelection = selection
  }
  //Reuse Selection
  @action updateIsReuseSelection(isReuseSelection) {
    this.isReuseSelection = isReuseSelection;
  }
  @action updateIsFirstTimeBet(isFirstTimeBet) {
    this.isFirstTimeBet = isFirstTimeBet;
  }
  @action updateIsChangeWinRiskByReuse(isChangeWinRiskByReuse) {
    this.isChangeWinRiskByReuse = isChangeWinRiskByReuse;
  }
  @action setAsiaReuseSingleSelection(selection) {
    this.asiaReuseSingleSelection = selection
  }

  @action setAsiaReuseOutrightSelection(selection) {
    this.asiaOutrightReuseSelection = selection
  }

  @action setAsiaTeaserReuseSelections(selections) {
    this.asiaTeaserReuseSelections = selections
  }

  @action setAsiaTeaserReuseStake(stake) {
    this.asiaTeaserReuseStake = stake
  }

  @action setAsiaReuseParlaySelections(selections) {
    this.asiaReuseParlaySelections = selections
  }

  @action setOddsReuseSelections(oddsReuseSelections) {
    this.oddsReuseSelections = oddsReuseSelections;
  }
  
  @action updateTicketId(ticketId) {
    this.ticketId = ticketId
  }

  @action addOddsReuseSelections(selection) {
    const tmp = this.oddsReuseSelections.filter(item => {
      return item.oddsId === selection.oddsId;
    })
    if (tmp.length < 1) {
      this.oddsReuseSelections.push(selection);
    }
  }

  @action addAsiaSingleSelection(selection) {
    this.asiaSingleSelection.unshift(selection)
  }

  @action updateSingleStakeInputs(data) {
    this.asiaSingleInputs = data
  }

  @action updateSingleStakeInputItem(oddIds, key, value) {
    this.asiaSingleInputs[oddIds][key] = value
  }

  @action removeSingleStakeInput(oddIds) {
    delete this.asiaSingleInputs[oddIds]
  }

  @action clearAsiaSingleSelection(index) {
    if (index) {
      this.asiaSingleSelection.splice(index, 1)
    }
    else {
      this.asiaSingleSelection = []
    }
  }

  @action reSelectSingleItem(selection) {
      this.validateWarning = '';
      this.newAsiaSingleData.stakePerBet = '';
      this.asiaSingleSelection = selection;
  }
  @action updateAsiaNormalBetItem(items) {
    this.asiaNormalBetItem = items
  }

  @action updateReuseAsiaNormalBets(singleBet) {
    this.reuseAsiaNormalBetItem = singleBet
  }

  @action updateReuseAsiaParlayBetItem(parlayBet) {
    this.reuseAsiaParlayBetItem = parlayBet
  }

  @action updateAsiaNormalItem(item, index) {
    if (!this.asiaNormalBetItem[index]) return
    this.asiaNormalBetItem[index] = { ...item }
  }

  @action updateReUseAsiaNormalItem(item, index) {
    if (!this.reuseAsiaNormalBetItem[index]) return
    this.reuseAsiaNormalBetItem[index] = { ...item }
  }

  @action updateReuseAsiaNormalBetItemStatus(status, index) {
    if (!this.reuseAsiaNormalBetItem[index]) return
    this.reuseAsiaNormalBetItem[index].status = status
  }

  @action updateExpandBetSlip(value) {
    this.isExpandBetSlip = value
  }

  @action removeSingleItem(oddsId) {
    this.newAsiaSingleData.stakePerBet = ''
    delete this.asiaSingleInputs[oddsId]
    this.asiaSingleSelection = this.asiaSingleSelection.filter(sel => sel.id !== oddsId)
    this.asiaNormalBetItem = this.asiaNormalBetItem.filter(bet => bet.oddsId !== oddsId)
    this.singleEventIdsHasCorrelated = this.singleEventIdsHasCorrelated.map(item => ({...item, maxBet: 0 }))
  }

  @action updateSingleInputItem(oddsId, item) {
    if(this.asiaSingleInputs[oddsId])
    this.asiaSingleInputs[oddsId] = item
  }

  @action removeAllSingleData() {
    this.newAsiaSingleData.stakePerBet = ''
    this.validateWarning = '';
    this.asiaSingleSelection = [];
    this.asiaNormalBetItem = [];
    this.asiaSingleInputs = {};
  }

  @action removeAllParlayData() {
    this.asiaSingleSelection = [];
    this.asiaParlayTicket = {}
    this.parlayBetSuccessRes = {}
    this.asiaParlayData = initAsiaParlayData
  }

  @action removeAllTeaserData() {
    this.updateAsiaTeaserTicket({});
    this.setAsiaTeaserSelections([]);
    this.clearOddsSelections();
    this.updateTeaserBetSuccessRes({});
    this.resetAsiaTeaserData();
  }

  @action setLoading(value) {
    this.isLoading = value
  }

  @action updateNewAsiaSingleData(key, value) {
    if (value !== null && value !== '' && typeof value !== 'object' && value === this.newAsiaSingleData[key]) {
      return;
    }

    this.newAsiaSingleData[key] = value;
  }

  @action updatePendingBets(bets) {
    this.newAsiaSingleData.pendingBets = [...bets]
  }

  @action updateBetslipDisp(value) {
    this.betslipDisp = value
  }

  @action setValidateWarning(value) {
    this.validateWarning = value
  }

  @action updateParlayBetSuccessRes(value) {
    this.parlayBetSuccessRes = {...value}
  }

  @action updateTeaserBetSuccessRes(value) {
    this.teaserBetSuccessRes = {...value}
  }

  @action setAsiaTeaserSelections(selections) {
    this.asiaTeaserSelections = selections
  }

  @action updateAsiaActiveBetslip(activeBetslip) {
    this.asiaActiveBetslip = activeBetslip
  }

  @action updateAsiaOutrightBetItem(item) {
    this.asiaOutrightBetItem = item
  }

  @action updateAsiaTeaserBetItem(item) {
   this.asiaTeaserBetItem = item
 }

  @action addAsiaTeaserSelections(selection) {
    if (!this.asiaTeaserSelections) {
      this.asiaTeaserSelections = []
    }
    this.asiaTeaserSelections.push(selection)
  }

  @action updateAsiaParlayBetItem(item) {
    this.asiaParlayBetItem = item
  }

  @action setAsiaParlayData(data) {
    this.asiaParlayData = data
  }

  @action setAsiaTeaserData(data) {
    this.asiaTeaserData = data
  }

  @action updateAsiaParlayData(key, value) {
    if (value !== null && value !== '' && typeof value !== 'object' && value === this.asiaParlayData[key]) {
      return;
    }

    this.asiaParlayData[key] = value;
  }

  @action updateAsiaParlayTicket(parlayTicket) {
    this.asiaParlayTicket = parlayTicket
  }

  @action updateAsiaTeaserTicket(teaserTicket) {
    this.asiaTeaserTicket = teaserTicket
  }

  @action updateAsiaPitchers(pitchers) {
    this.asiaPitchers = pitchers
  }

  @action updateAsiaTeaserData(key, value) {
    if (value !== null && value !== '' && typeof value !== 'object' && value === this.asiaTeaserData[key]) {
      return;
    }

    this.asiaTeaserData[key] = value;
  }

  @action setTeaserBetItems(teaserBetItems) {
    this.teaserBetItems =  teaserBetItems;
  }

  @action updateDisplayMaxBetWarning(value) {
    this.displayMaxBetWarning = value
  }

  @action updateReuseAsiaParlayData(data) {
    this.reuseAsiaParlayData = data
  }

  @action updateReuseAsiaSingleInputs(data) {
    this.reuseAsiaSingleInputs = data
  }

  @action updateSelectionOdds(data, index) {
    this.asiaSingleSelection[index].odds = data
  }

  @action updateMaxParlayOdds(data) {
    this.maxParlayOdds = data
  }
  @action setParlayMaxOddsError(data) {
    this.isParlayMaxOddsError = data
  }

  @action updateSingleEventIdsHasCorrelated(data) {
    this.singleEventIdsHasCorrelated = data
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/NewBetslipStore.js